import React, {FC, useEffect, useMemo, useState} from "react";
import {CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile} from "@brg/ui";
import {LayoutConst} from "../../../../core";
import {useTranslation} from "react-i18next";
import {ProjectEditPageGridInput} from "../../../../_deziiign/books/pages/BookEdit/styles";
import {JustTable} from "../../../../_competition/components/style";
import SortableList, {SortableItem, SortableKnob} from "react-easy-sort";
import {DefaultButton, TableSortWrapper, TeamEditLabel} from "../styles";
import {DottedIcon} from "../../../icons/DottedIcon";
import {Input} from "@brg/input";
import EditIcon24 from "../../../icons/EditIcon24";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import {useGetModulesList} from "../../../hooks/api/LMS/useGetModulesList";
import {ProjectEditPageGridRow} from "../../projectEdit/styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {API, Endpoints} from "@brg/api";
import { useGetLMSDisciplines } from "shared/hooks/api/LMS/useGetLMSDisciplines";
import { getDisciplineColorFromId } from "shared/helpers/LMS/getDisciplineColorFromId";

export const ModulesOrder: FC<{ teamId?: string, onModalStateChange?: any }> = ({ teamId, onModalStateChange }) => {

    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const isMobile = useIsMobile();
    const isSmallMob = useBreakpoint(LayoutConst.screen.xsm);
    const { t } = useTranslation();
    const { disciplines, colors: disciplineColors } = useGetLMSDisciplines(teamId || '')
    const disciplinesIds = useMemo(() => disciplines.map(discipline => discipline.id),[disciplines])
    const { modules: modulesRaw } = useGetModulesList(teamId, disciplinesIds)
    const [modules, setModules] = useState([])
    

    useEffect(() => {
        setModules(modulesRaw)
    }, [modulesRaw])

    const onSortEnd = (oldIndex: number, newIndex: number) => {
        const newModules = arrayMoveImmutable(modules, oldIndex, newIndex)
        setModules(newModules);

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/UpdateModulePositions')
            .body(newModules?.map((i: any) => i?.projectId || "") || [])
            .post()
            .release()
            .then((res: any) => res)
    }

    const onEdit = (id: any) => {
        const currentOrigin = window.location.origin;
        window.open(currentOrigin + CreateLinkTo.projectEdit(id), '_blank')
    }

    const onCreate = () => {
        const currentOrigin = window.location.origin;
        window.open(currentOrigin + CreateLinkTo.projectCreateByOrganization(teamId || ''), '_blank')
    }

    return (
        <ProjectEditPageGridRow align="flex-start" alignMobile="flex-start" style={{marginTop: isS? 24 : 40}} isTeamEdit >
            <CommonLabel 
                label={t('teams.adminPage.fields.modules')}
            />
        <FlexBox direction="column" directionMobile="column" widthMobile={'100%'}>
            <ProjectEditPageGridInput  isTeamEdit direction={!!modules?.length ? 'column' : 'row'} style={{flexDirection: isMobile ? 'column' : 'inherit'}}>
                {!!modules?.length && (
                    <JustTable isTeamEdit>
                        <thead>
                        <tr>
                            <th style={{width: '45%', paddingTop: 0 }}>{t('teams.adminPage.additionalFields.td_name')}</th>
                            <th style={{width: '22%', whiteSpace: 'nowrap', textAlign: 'center', paddingTop: 0 }}></th>
                            {!isS && (
                                <th style={{width: isS ? 0 : '30%', paddingTop: 0}}></th>
                            )}
                        </tr>
                        </thead>
                        <SortableList as={'tbody'} onSortEnd={onSortEnd}>
                            {modules.map((module: any, index: number) => {
                                const discipline = module?.additionalInfo?.lmsmodule_discipline
                                
                                //@ts-ignore
                                return (
                                    <SortableItem key={"team-tab-sortable_" + index}>
                                    <tr>
                                        <td style={{ width: isMobile ? '100%' :'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                            <TableSortWrapper direction={'row'} directionMobile="row" align={'center'} backgroundColor={getDisciplineColorFromId(discipline, disciplineColors)}>
                                                <SortableKnob>
                                                    <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
                                                        <DottedIcon />
                                                    </div>
                                                </SortableKnob>
                                                <CommonInput 
                                                    type={INPUT_TYPES.text}
                                                    value={module?.title}
                                                    disable={true}
                                                    onChange={() => null}
                                                />
                                            </TableSortWrapper>
                                        </td>
                                        <td style={{ width: isS ? '56px' : '336px' }}>
                                            <FlexBox direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                                                {isS ? (
                                                    <EditIcon24 onClick={() => onEdit(module?.projectId)}/>
                                                ) : (
                                                    <DefaultButton wh={181} whMob={157}  style={{ marginBottom: 5 }} onClick={() => onEdit(module?.projectId)}>
                                                        {t('teams.adminPage.buttons.edit')}
                                                    </DefaultButton>
                                                )}
                                            </FlexBox>
                                        </td>
                                    </tr>
                                    </SortableItem>
                                );
                            })}
                        </SortableList>
                    </JustTable>
                )}
                <FlexBox style={{ marginTop: !modules?.length ? 0 : isSmallMob ? 10 : 24}}>
                    <DefaultButton wh={195} whMob={195} onClick={() => {
                        onCreate();
                    }}>
                        <PlusSvg />
                        {t('teams.adminPage.buttons.create')}
                    </DefaultButton>
                </FlexBox>
            </ProjectEditPageGridInput>
        </FlexBox>
        </ProjectEditPageGridRow>
    )
}import React, {FC, useEffect, useMemo, useState} from "react";
import {CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile} from "@brg/ui";
import {LayoutConst} from "../../../../core";
import {useTranslation} from "react-i18next";
import {ProjectEditPageGridInput} from "../../../../_deziiign/books/pages/BookEdit/styles";
import {JustTable} from "../../../../_competition/components/style";
import SortableList, {SortableItem, SortableKnob} from "react-easy-sort";
import {DefaultButton, TableSortWrapper, TeamEditLabel} from "../styles";
import {DottedIcon} from "../../../icons/DottedIcon";
import {Input} from "@brg/input";
import EditIcon24 from "../../../icons/EditIcon24";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import {useGetModulesList} from "../../../hooks/api/LMS/useGetModulesList";
import {ProjectEditPageGridRow} from "../../projectEdit/styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {API, Endpoints} from "@brg/api";
import { useGetLMSDisciplines } from "shared/hooks/api/LMS/useGetLMSDisciplines";
import { getDisciplineColorFromId } from "shared/helpers/LMS/getDisciplineColorFromId";

export const ModulesOrder: FC<{ teamId?: string, onModalStateChange?: any }> = ({ teamId, onModalStateChange }) => {

    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const isMobile = useIsMobile();
    const isSmallMob = useBreakpoint(LayoutConst.screen.xsm);
    const { t } = useTranslation();
    const { disciplines, colors: disciplineColors } = useGetLMSDisciplines(teamId || '')
    const disciplinesIds = useMemo(() => disciplines.map(discipline => discipline.id),[disciplines])
    const { modules: modulesRaw } = useGetModulesList(teamId, disciplinesIds)
    const [modules, setModules] = useState([])
    

    useEffect(() => {
        setModules(modulesRaw)
    }, [modulesRaw])

    const onSortEnd = (oldIndex: number, newIndex: number) => {
        const newModules = arrayMoveImmutable(modules, oldIndex, newIndex)
        setModules(newModules);

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/UpdateModulePositions')
            .body(newModules?.map((i: any) => i?.projectId || "") || [])
            .post()
            .release()
            .then((res: any) => res)
    }

    const onEdit = (id: any) => {
        const currentOrigin = window.location.origin;
        window.open(currentOrigin + CreateLinkTo.projectEdit(id), '_blank')
    }

    const onCreate = () => {
        const currentOrigin = window.location.origin;
        window.open(currentOrigin + CreateLinkTo.projectCreateByOrganization(teamId || ''), '_blank')
    }

    return (
        <ProjectEditPageGridRow align="flex-start" alignMobile="flex-start" style={{marginTop: isS? 24 : 40}} isTeamEdit >
            <CommonLabel 
                label={t('teams.adminPage.fields.modules')}
            />
        <FlexBox direction="column" directionMobile="column" widthMobile={'100%'}>
            <ProjectEditPageGridInput  isTeamEdit direction={!!modules?.length ? 'column' : 'row'} style={{flexDirection: isMobile ? 'column' : 'inherit'}}>
                {!!modules?.length && (
                    <JustTable isTeamEdit>
                        <thead>
                        <tr>
                            <th style={{width: '45%', paddingTop: 0 }}>{t('teams.adminPage.additionalFields.td_name')}</th>
                            <th style={{width: '22%', whiteSpace: 'nowrap', textAlign: 'center', paddingTop: 0 }}></th>
                            {!isS && (
                                <th style={{width: isS ? 0 : '30%', paddingTop: 0}}></th>
                            )}
                        </tr>
                        </thead>
                        <SortableList as={'tbody'} onSortEnd={onSortEnd}>
                            {modules.map((module: any, index: number) => {
                                const discipline = module?.additionalInfo?.lmsmodule_discipline
                                
                                //@ts-ignore
                                return (
                                    <SortableItem key={"team-tab-sortable_" + index}>
                                    <tr>
                                        <td style={{ width: isMobile ? '100%' :'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                            <TableSortWrapper direction={'row'} directionMobile="row" align={'center'} backgroundColor={getDisciplineColorFromId(discipline, disciplineColors)}>
                                                <SortableKnob>
                                                    <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
                                                        <DottedIcon />
                                                    </div>
                                                </SortableKnob>
                                                <CommonInput 
                                                    type={INPUT_TYPES.text}
                                                    value={module?.title}
                                                    disable={true}
                                                    onChange={() => null}
                                                />
                                            </TableSortWrapper>
                                        </td>
                                        <td style={{ width: isS ? '56px' : '336px' }}>
                                            <FlexBox direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                                                {isS ? (
                                                    <EditIcon24 onClick={() => onEdit(module?.projectId)}/>
                                                ) : (
                                                    <DefaultButton wh={181} whMob={157}  style={{ marginBottom: 5 }} onClick={() => onEdit(module?.projectId)}>
                                                        {t('teams.adminPage.buttons.edit')}
                                                    </DefaultButton>
                                                )}
                                            </FlexBox>
                                        </td>
                                    </tr>
                                    </SortableItem>
                                );
                            })}
                        </SortableList>
                    </JustTable>
                )}
                <FlexBox style={{ marginTop: !modules?.length ? 0 : isSmallMob ? 10 : 24}}>
                    <DefaultButton wh={195} whMob={195} onClick={() => {
                        onCreate();
                    }}>
                        <PlusSvg />
                        {t('teams.adminPage.buttons.create')}
                    </DefaultButton>
                </FlexBox>
            </ProjectEditPageGridInput>
        </FlexBox>
        </ProjectEditPageGridRow>
    )
}